import React from "react";
import { Spinner } from "@fluentui/react-components";
import { Page } from "./Page";
import { useQuery } from "@apollo/client/react";
import { GET_FAQSECTION } from "../graphql/queries";
import { HeroFaq } from "../components/hero/HeroFaq";
import { QuestionAnswers } from "../components/faq/QuestionAnswers";
import { FaqSection } from "../graphql/schema";
import { Error } from "./Error";
import { useCmsLocale } from "../i18n/cmsLocale";

export const Faq = () => {
  const locale = useCmsLocale();
  const { data, loading, error } = useQuery(GET_FAQSECTION, { variables: { locale } });
  if (loading) return <Spinner style={{ marginTop: "30vh" }} size="huge" />;
  if (error || !data.faqSection)
    return <Error error={error ? error.message : "faqSection"} />;
  const faqSection: FaqSection = data.faqSection;

  return (
    <Page>
      <HeroFaq faqSection={faqSection} />
      <QuestionAnswers faqSection={faqSection} />
    </Page>
  );
};
